import { useEffect, useState } from "react";

import moment from "moment";
import { MDBTableHead, MDBTable, MDBTableBody } from "mdbreact";
import { Loader } from "../../../../../../../../UI/Loaders/Loaders";
import { appInsights } from "../../../../../../../../config/appInsights";
import { useLocation, useRouteMatch } from "react-router-dom";
import { formatMoney } from "../../../../../../../../helpers/formatter";
import { useCustomerUnCompletedTransactions } from "../../../../../../../../custom-hooks/useCustomerUnCompletedTransactions";
import Paginator from "../../../../../../../Pagination/Pagination.component";

const UnCompletedTransactions = () => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const location = useLocation();

  const match = useRouteMatch();
  const { id } = match?.params as { id: number };

  const state = location.state as {
    customerId: number;
    accountNumber: string;
    accountName: string;
    walletProvider: string;
  };

  useEffect(() => {
    appInsights.trackPageView({
      name: "UncompletedTransactions.tsx",
      isLoggedIn: true,
    });
  }, []);

  const {
    data: customerTransactions,
    status,
    error,
  } = useCustomerUnCompletedTransactions({
    customerId: state?.customerId,
    page,
    pageSize,
    walletId: id,
    walletProvider: state?.walletProvider,
  });

  console.log("customerTransactions: ", customerTransactions);

  let RenderedComponent = null;
  if (!customerTransactions && status !== "loading") {
    RenderedComponent = (
      <div>
        <div className="grid__padding animated fadeInRight">
          <h4 className="center-txt">
            <i className="fas fa-bell" /> Unable to Fetch Transactions
          </h4>
        </div>
      </div>
    );
  } else if (status === "loading") {
    RenderedComponent = (
      <Loader centered={true} text="Loading Transactions..." />
    );
  } else {
    if (error) {
      RenderedComponent = (
        <div>
          <div className="grid__padding animated fadeInRight">
            <h4 className="center-txt p-y-5">
              <i className="fas fa-bell" /> There was an issue while fetching
              Transactions Please Reload The Page{" "}
            </h4>
          </div>
        </div>
      );
    } else if (
      (customerTransactions &&
        customerTransactions.data &&
        customerTransactions.data.length === 0) ||
      (customerTransactions && !customerTransactions.data)
    ) {
      RenderedComponent = (
        <div className="centerLoader">
          <div className="grid__padding animated fadeInRight">
            <h4 className="center-txt p-y-5">
              <i className="fas fa-bell" /> There are currently no transactions
            </h4>
          </div>
        </div>
      );
    } else {
      RenderedComponent = (
        <>
          <MDBTable
            responsive
            minimal="true"
            striped={false}
            bordered
            hover
            id="table-to-xls"
          >
            <MDBTableHead>
              <tr>
                <th>S/N</th>
                <th>Transaction Type</th>
                <th>Amount</th>
                <th>Transaction Date</th>
                <th>Description</th>
                <th>Maker Checker Reference</th>
                <th>Maker Checker Status</th>
                <th>Recipient Account Name</th>
                <th>Recipient Account Number</th>
                <th>Recipient Bank Name</th>
                <th>Status</th>
              </tr>
            </MDBTableHead>
            <MDBTableBody>
              {customerTransactions &&
                customerTransactions.data.map((data, _id: number) => {
                  const {
                    amount,
                    createdBy,
                    currency,
                    description,
                    makerCheckerReference,
                    makerCheckerStatus,
                    pubDate,
                    recipientAccountName,
                    recipientAccountNumber,
                    recipientBankName,
                    status,
                    transactionDate,
                    transactionType,
                  } = data;
                  return (
                    <tr key={_id}>
                      <td>{_id + 1}</td>
                      <td>{transactionType}</td>
                      <td>{formatMoney(amount, currency)}</td>
                      <td>
                        {transactionDate
                          ? moment(transactionDate).format("DD-MM-YYYY")
                          : ""}
                      </td>
                      <td>{description}</td>
                      <td>{makerCheckerReference}</td>
                      <td>{makerCheckerStatus}</td>
                      <td>{recipientAccountName}</td>
                      <td>{recipientAccountNumber}</td>
                      <td>{recipientBankName}</td>
                      <td>{status}</td>
                    </tr>
                  );
                })}
            </MDBTableBody>
          </MDBTable>
        </>
      );
    }
  }

  return (
    <div className="table-view speed-1x animated fadeInRight">
      <div>{RenderedComponent}</div>
      <Paginator
        size={pageSize}
        page={page}
        count={customerTransactions?.totalCount}
        changeCurrentPage={(pageNumber: number) => setPage(pageNumber)}
      />
    </div>
  );
};

export default UnCompletedTransactions;
